import { render, staticRenderFns } from "./paginationNew.vue?vue&type=template&id=30249cf8&"
import script from "./paginationNew.vue?vue&type=script&lang=js&"
export * from "./paginationNew.vue?vue&type=script&lang=js&"
import style0 from "./paginationNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "paginationNew.vue"
export default component.exports